import { SelectedFiltersSkeleton } from "@components/SelectedFilters";
import MonthNavigationSkeleton from "@components/Skeletons/MonthNavigationSkeleton";
import KpiCardsSkeleton from "@components/Skeletons/KpiCardsSkeleton";
import CategoryCardSkeleton from "./CategoryCardSkeleton";
import DRETableSkeleton from "./DRETableSkeleton";
import FinancialEvolutionChartSkeleton from "./FinancialEvolutionChartSkeleton";

export default function DashboardSkeleton() {
  return (
    <div className="width-100pct height-100pct display-flex flex-column bg-lighest">
      <div className="flex-1 overflow-y-auto">
        <div className="display-flex flex-column gap-10 gap-20-sm padding-10 padding-25-sm bg-light">
          <MonthNavigationSkeleton />

          <SelectedFiltersSkeleton />
        </div>

        <div className="padding-10 padding-25-sm">
          <KpiCardsSkeleton className="display-grid grid-cols-1 grid-cols-2-sm grid-cols-4-lg gap-10 margin-bottom-20" />

          <DRETableSkeleton />

          <div className="display-grid grid-cols-1 grid-cols-2-md gap-10 gap-20-sm margin-bottom-20">
            <CategoryCardSkeleton />
            <CategoryCardSkeleton />
          </div>

          <FinancialEvolutionChartSkeleton />
        </div>
      </div>
    </div>
  );
}
